// SocketProvider.ts
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import { io, Socket } from "socket.io-client";

const SocketContext = createContext<Socket | null>(null);

interface SocketProviderProps {
  children: ReactNode;
}

import { backendUrl } from "../utils/Environment";

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    const newSocket = io(backendUrl, {
      withCredentials: true,
    });

    newSocket.on("connect", () => {
      console.log("[Socket.io] Connected -> ", newSocket.id);
    });

    newSocket.on("connect_error", (err) => {
      console.error("[Socket.io] Connection error -> ", err);
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, [backendUrl]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export const useSocket = (): Socket | null => {
  return useContext(SocketContext);
};
